module.exports = __webpack_public_path__ + "img/jucai2.78c0cb77.jpg";